export type Fetch = typeof fetch;
